export const environment = {
  production: true,
  //splixerUrl: 'https://player-api.tkatlabs.com/player_api/v3/',
  splixerUrl: 'https://player-api.splixer.com/player_api/v3/',
  defaultStationCode: '30b07b51-7513-4a42-b6b5-ed783b270d0b',
  defaultGaTrackingId: 'G-F8K65H4YNJ',
};
